import React from "react";
import { FaCheckCircle } from "react-icons/fa";

function HowItWorksSection() {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-center -mx-4">
          {/* Left Content */}
          <div className="w-full md:w-1/2 px-4 mb-8 md:mb-0">
            <h2 className="text-4xl font-bold mb-6 text-gray-900 leading-snug">
              How do I find the right expert?
            </h2>
            <p className="text-gray-600 mb-8 text-lg max-w-lg">
              Exponent’s unique algorithm matches you with vetted experts that
              are a perfect fit for what you actually need Marketing experts in
              your niche.
            </p>

            <ul className="space-y-4">
              <li className="flex items-start">
                <FaCheckCircle className="text-[rgba(10,192,171,1)] mr-3 mt-1" />
                <span className="text-gray-700">
                  Stop blindly sifting through lists of recommendations searching.
                </span>
              </li>
              <li className="flex items-start">
                <FaCheckCircle className="text-[rgba(10,192,171,1)] mr-3 mt-1" />
                <span className="text-gray-700">
                  Stop wasting time listening to questionable sales pitches.
                </span>
              </li>
              <li className="flex items-start">
                <FaCheckCircle className="text-[rgba(10,192,171,1)] mr-3 mt-1" />
                <span className="text-gray-700">
                  Stop losing money to lazy marketing providers.
                </span>
              </li>
            </ul>
          </div>

          {/* Right Expert Card */}
          <div className="w-full md:w-1/2 px-4 flex justify-center">
            <div className="border rounded-lg shadow-md bg-white w-full max-w-md p-4 relative">
              <h5 className="text-gray-500 text-xs mb-2 font-semibold">EXPONENT EXPERTS</h5>

              {/* Table Header */}
              <div className="flex justify-between text-sm text-gray-700 font-semibold border-b pb-2 mb-4">
                <span>EXPERTS</span>
                <span>PROPOSAL STATUS</span>
              </div>

              {/* Expert List */}
              <div className="space-y-3">
                {/* Expert 1 */}
                <div className="flex justify-between items-center p-2 border rounded">
                  <div className="flex items-center">
                    <img
                      src="https://randomuser.me/api/portraits/women/44.jpg"
                      alt="Expert 1"
                      className="w-10 h-10 rounded-full object-cover mr-3"
                    />
                    <div>
                      <p className="font-semibold text-gray-800">Gaey Rillott</p>
                      <p className="text-xs text-gray-500 flex items-center">
                        <span className="text-yellow-400 mr-1">★</span> Pro in Food & Drinks
                      </p>
                    </div>
                  </div>
                  <span className="text-xs bg-gray-100 px-2 py-1 rounded text-gray-600">
                    Reviewing
                  </span>
                </div>

                {/* Expert 2 */}
                <div className="flex justify-between items-center p-2 border rounded">
                  <div className="flex items-center">
                    <img
                      src="https://randomuser.me/api/portraits/men/22.jpg"
                      alt="Expert 2"
                      className="w-10 h-10 rounded-full object-cover mr-3"
                    />
                    <div>
                      <p className="font-semibold text-gray-800">Rillott Gaey</p>
                      <p className="text-xs text-gray-500 flex items-center">
                        <span className="text-yellow-400 mr-1">★</span> Pro in B2B
                      </p>
                    </div>
                  </div>
                  <span className="text-xs bg-gray-100 px-2 py-1 rounded text-gray-600">
                    Reviewing
                  </span>
                </div>

                {/* Expert 3 */}
                <div className="flex justify-between items-center p-2 border rounded">
                  <div className="flex items-center">
                    <img
                      src="https://randomuser.me/api/portraits/women/65.jpg"
                      alt="Expert 3"
                      className="w-10 h-10 rounded-full object-cover mr-3"
                    />
                    <div>
                      <p className="font-semibold text-gray-800">Gaey Rillott</p>
                      <p className="text-xs text-gray-500 flex items-center">
                        <span className="text-yellow-400 mr-1">★</span> Pro in Socials Media
                      </p>
                    </div>
                  </div>
                  <span className="text-xs bg-gray-100 px-2 py-1 rounded text-gray-600">
                    Reviewing
                  </span>
                </div>
              </div>

              {/* Footer */}
              <div className="bg-[rgba(10,192,171,0.1)] text-[rgba(10,192,171,1)] text-sm text-center p-2 mt-4 rounded">
                Selected for your project from more than 2500 marketers
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HowItWorksSection;

